import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import isToday from 'date-fns/is_today';
import { format } from 'date-fns';

// Utils
import { clickEvent } from 'utils/adaConfigurations/customEvents';
import './CalendarDay.scss';
const ns = 'calendar-day';

const CalendarDay = props => {
  const { disabled, active, className, date, intl, promotion, onClick } = props;
  const monthDayFormatted = format(date, 'MMMM Do');
  const classProps = classnames(
    ns,
    {
      [`${ns}--disabled`]: disabled,
      [`${ns}--active`]: active,
      [`${ns}--today`]: isToday(date),
      [`${ns}--empty`]: !date,
      [`${ns}--promotion`]: promotion
    },
    className
  );
  return (
    <span
      className={classProps}
      onClick={() => {
        !disabled && onClick(date);
      }}
      onKeyUp={e => {
        !disabled && clickEvent(e);
      }}
      tabIndex={disabled ? -1 : 0}
      aria-label={monthDayFormatted}
      aria-disabled={disabled}
    >
      {date
        ? intl.formatDate(date, {
            day: 'numeric'
          })
        : ' '}
    </span>
  );
};

CalendarDay.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  date: PropTypes.instanceOf(Date),
  disabled: PropTypes.bool,
  intl: PropTypes.object,
  onClick: PropTypes.func,
  promotion: PropTypes.bool
};

CalendarDay.defaultProps = {
  active: false,
  className: '',
  disabled: false,
  onClick: () => {},
  promotion: true
};

export default CalendarDay;



// WEBPACK FOOTER //
// ./src/components/atoms/CalendarDay/CalendarDay.js